import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTranslateText } from '@/hooks/useTranslateText'

interface TranslatableTextProps {
  text: string
  className?: string
}

export function TranslatableText({ text, className }: TranslatableTextProps) {
  const { i18n, t } = useTranslation()
  const [requested, setRequested] = useState(false)
  const [showOriginal, setShowOriginal] = useState(false)

  const isNonEnglish = i18n.language !== 'en'
  const { translatedText, isLoading, error } = useTranslateText(
    text,
    i18n.language,
    isNonEnglish && requested
  )

  if (!isNonEnglish) {
    return <span className={className}>{text}</span>
  }

  const showTranslated = requested && !showOriginal && !!translatedText

  const handleTranslate = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!requested) {
      setRequested(true)
    } else if (translatedText) {
      setShowOriginal((prev) => !prev)
    }
  }

  let buttonLabel: string
  if (isLoading) {
    buttonLabel = `${t('translate')}...`
  } else if (error && requested) {
    buttonLabel = t('translate')
  } else if (showTranslated) {
    buttonLabel = t('showOriginal')
  } else if (requested && translatedText && showOriginal) {
    buttonLabel = t('showTranslation')
  } else {
    buttonLabel = t('translate')
  }

  return (
    <span className={className}>
      {showTranslated ? translatedText : text}
      <button
        type="button"
        onClick={handleTranslate}
        disabled={isLoading}
        className={`ml-1.5 text-[11px] transition-colors font-medium ${
          isLoading
            ? 'text-cyan-400/50 animate-pulse cursor-wait'
            : 'text-cyan-400/70 hover:text-cyan-400 cursor-pointer'
        }`}
      >
        {buttonLabel}
      </button>
    </span>
  )
}
